export default __webpack_public_path__ + "empty-cart.svg?48947eb11de87741e3e12cb7930a81bd";